//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

    props: {
        seladd: {
            required: true,
            default: 0
        }
    },
    data: function data() {
        return {
            initialized: false,
            cartEmpty: true,
            user: null
        };
    },


    computed: {
        processUrl: function processUrl() {
            return App.url + '/checkout/process';
        },
        token: function token() {
            return App.token;
        }
    },

    methods: {
        fetchUser: function fetchUser() {
            var _this = this;

            new Form().get('/api/me').then(function (user) {
                _this.user = user;
                _this.user.name = _this.user.firstName + " " + _this.user.lastName;
                _this.initialized = true;
                App.event.fire('user.logged-in', user);
                App.event.fire('billing.changed', user.billing);
            }).catch(function (error) {
                _this.initialized = true;
                App.event.fire('user.logged-out', error);
            });
        },
        validate: function validate() {
            if (this.$refs.shipping.validate()) {
                this.$refs.form.submit();
            }
        }
    },

    created: function created() {
        this.fetchUser();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}],"syntax-dynamic-import"]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/templates/semperit/assets/js/modules/checkout/components/Checkout.vue
// module id = 6O6k
// module chunks = 4